export default function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-collection/src/values.js
// module id = qwPj
// module chunks = 0